import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom'
import { useState, useEffect, useCallback } from "react"

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_URL

  const [club, setClub] = useState([])

  const getClub = useCallback(async () => {
    try {
      const response = await fetch(`${url}/club`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const [data] = await response.json(); // Assuming the API returns an array
        setClub(data);
      } else {
        console.error("Error fetching club data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching club data:", error);
    }
  }, [url]);

  useEffect(() => {
    getClub(); // Fetch club data on component mount
  }, [getClub]);


  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center mb-4">
          <Col xs={12} md={6} xl={6}>
            {club &&
              <div inline='true' className="m-2">
                <p>Developed and maintained by <a href="https://marius-c.webhop.me/" target="_blank" rel="noreferrer">marius-c</a></p>
                <p>Support the developer: <a href="https://www.paypal.me/mariuscornescu" target="_blank" rel="noreferrer">PayPal</a> | <a href="https://revolut.me/mariusdbtv" target="_blank" rel="noreferrer">Revolut</a><br />
                  Donations are voluntary and non-refundable
                </p>
                <p><Link to={'/t&c'}>Terms and Conditions</Link></p>
              </div>
            }
          </Col>
          <Col xs={12} md={6} xl={6} className="text-center text-sm-end">
            <Row className="social-icon">
              {club &&
                <Col className="text-end">
                  {club?.linkedInVisible && <a href={club?.linkedIn ? club?.linkedIn : ''} target="_blank" rel="noreferrer"><i className="bi bi-linkedin" /></a>}
                  {club?.facebookVisible && <a href={club?.facebook ? club?.facebook : ''} target="_blank" rel="noreferrer"><i className="bi bi-facebook" /></a>}
                  {club?.instagramVisible && <a href={club?.instagram ? club?.instagram : ''} target="_blank" rel="noreferrer"><i className="bi bi-instagram" /></a>}
                  {club?.xVisible && <a href={club?.x ? club?.x : ''} target="_blank" rel="noreferrer"><i className="bi bi-twitter-x" /></a>}
                  {club?.youtubeVisible && <a href={club?.youtube ? club?.youtube : ''} target="_blank" rel="noreferrer"><i className="bi bi-youtube" /></a>}


                  {/* <a href="https://www.linkedin.com/groups/4129031/" target='_blank' rel="noreferrer"><img src={navIcon1} alt="Linkedin Icon Footer" /></a>
                <a href="https://www.facebook.com/BrnoToastmasters/" target='_blank' rel="noreferrer"><img src={navIcon2} alt="Facebook Icon footer" /></a>
                <a href="https://youtube.com/playlist?list=PL50Fjntx45Ga6ANLDDD6FNj7Benaebndj&si=BTcYMsYyu7GltipP" target='_blank' rel="noreferrer"><img src={youTube} alt="YouTube Icon footer" /></a> */}
                </Col>
              }
            </Row>
            <Row className="text-end">
              <Col className="text-end">
                {/* <p className="text-end">{club?.type}</p> */}
                <h4 className="text-end">{club?.name}</h4>
                <p className="text-end">
                  {`Club Number: ${club?.number}`}<br />
                  {`Area: ${club?.area}, Division ${club?.division}, District ${club?.district}, Region ${club?.region}`}
                </p>
                <p className="text-end">© {currentYear} {club?.name}. All Rights Reserved. </p>

              </Col>
            </Row>
          </Col>
        </Row>
      </Container >
    </footer >
  )
}